import { Seconds } from '@mi-front/core';
import { Duration, PaginatedTable } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { LDate } from '../../../../../../components/date/LDate';
import { LTime } from '../../../../../../components/date/LTime';
import { TimezoneCtxProvider } from '../../../../../../core/context/timezone';
import { ReportResultProps } from '../../../../../../core/reports/types';
import { ConsecutiveSchedulesReport } from '../types';

export function ConsecutiveSchedulesReportResult({
  result,
}: ReportResultProps<ConsecutiveSchedulesReport>) {
  const { $t } = useIntl();

  return (
    <PaginatedTable
      data={result.items}
      columns={[
        {
          Header: $t({
            id: 'common.station',
            defaultMessage: 'Emisora',
          }),
          accessor: (item) => item.stationSlug,
          w: 15,
        },
        {
          Header: $t({
            id: 'audit.props.customId',
            defaultMessage: 'Custom ID',
          }),
          accessor: (item) => item.customId,
          w: 15,
        },
        {
          Header: $t({
            id: 'common.datetime',
            defaultMessage: 'Fecha y hora',
          }),
          accessor: (item) => (
            <TimezoneCtxProvider
              value={{
                timezone: item.timezone,
              }}
            >
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <LDate value={item.datetime} day="2-digit" month="2-digit" year="2-digit" />
                <LTime value={item.datetime} second={'numeric'} />
              </div>
            </TimezoneCtxProvider>
          ),
          w: 15,
        },
        {
          Header: $t({
            id: 'audit.consecutiveSchedules.datetimeNext',
            defaultMessage: 'Fecha y hora siguiente',
          }),
          accessor: (item) => (
            <TimezoneCtxProvider
              value={{
                timezone: item.timezone,
              }}
            >
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <LDate value={item.datetimeNext} day="2-digit" month="2-digit" year="2-digit" />
                <LTime value={item.datetimeNext} second={'numeric'} />
                <Duration
                  seconds={
                    ((new Date(item.datetimeNext).valueOf() - new Date(item.datetime).valueOf()) /
                      1000) as Seconds
                  }
                />
              </div>
            </TimezoneCtxProvider>
          ),
          w: 15,
        },
        {
          Header: $t({
            id: 'audit.props.audioDuration',
            defaultMessage: 'Duración del audio',
          }),
          accessor: (item) => <Duration seconds={Number(item.audioDuration) as Seconds} />,
          w: 10,
        },
      ]}
    />
  );
}
